import styled from "@emotion/styled";
import { Card as MuiCard } from "@mui/material";

export const PaymentPage = styled("div")`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Card = styled(MuiCard)`
  width: 100%;
  height: 100vh;
  max-width: 600px;
  /* max-width: 400px; */
  max-height: 650px;
  /* max-height: 300px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;

export const StatusIcon = styled("img")`
  width: 60px;
  margin: 60px 0 20px 0;
`;

export const StatusText = styled("p")(
  ({ isPaymentSuccess }) => `
  color: ${isPaymentSuccess ? "#74c6a5" : "#E65741"};
  margin-top: 0;
  font-size: 24px;
`
);

export const PaymentDetails = styled("div")`
  width: 80%;
  margin: 50px 0;

  .amount-field {
    font-size: 20px;
  }
`;

export const Field = styled("div")`
  color: #a1a2aa;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;

  .rupee-symbol {
    font-size: 22px;
  }

  span {
    font-weight: 700;
  }
`;
